import React from 'react'
import Button from 'components/Common/Button'

const ToolsGuideCardChild = ({ description, updateOwnerProfile, Icon, type }) => {
  return (
    <>
      <div className="tools-guide">
        <Icon className="w-[78px] h-[78px] m-auto" />
        <p className="tools-guide-description">{description}</p>
        {/* check-button -- clean up custom styles */}
        <Button
          label="Get Started"
          onClick={() => updateOwnerProfile(type)}
          variant="secondary"
          className="tools-guide-btn w-full"
        />
      </div>
    </>
  )
}

export default ToolsGuideCardChild
